import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToastComponent } from './components';
import { ToastService } from './services';

@NgModule({
  imports: [CommonModule],
  declarations: [ToastComponent],
  providers: [ToastService],
  exports: [ToastComponent],
})
export class ToastModule {}
